module.exports = __webpack_public_path__ + "static/assets/6a3b3fd189cd9b61963721dc73b19829.png";